import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';

import * as styles from '../../../styles';
import {imageUrl} from '../../../utilities/requests';


export default class PrintQuestionsReport extends React.PureComponent {
    static contextTypes = {
        store: PropTypes.object,
    }

    render() {
        const subjects = _.mapKeys(this.props.examination.subjects, item => item.id);
        const questions = _.sortBy(this.props.examination.questions, 'index');
        const Td = props => <td {...props} style={{...styles.softTd, ...(props.style || {})}}>{props.children}</td>;
        const Mtd = props => <td {...props} style={{...styles.softTd, textAlign: 'center', ...(props.style || {})}}>
            {props.children}
        </td>;
        const Th = props => <th {...props} style={{...styles.softTh, ...(props.style || {})}}>{props.children}</th>;
        const Mth = props => <th {...props} style={{...styles.softTh, textAlign: 'center', ...(props.style || {})}}>
            {props.children}
        </th>;
        return <div
            style={{
                fontSize: '.9em',
                position: 'relative',
                width: '209mm',
                height: '295mm',
                pageBreakAfter: this.props.last ? undefined : 'always',
            }}>
            <div
                style={{
                    position: 'fixed',
                    top: '26mm',
                    right: '46mm',
                    width: '52mm',
                    fontSize: '1.40em',
                }}>
                <div style={{textAlign: 'center'}}>
                    <b>{window.gettext('Teacher Report')}</b>
                </div>
            </div>
            <div
                style={{
                    position: 'fixed',
                    top: '8mm',
                    right: '102mm',
                    width: '63.2mm',
                }}>
                <div style={{overflow: 'hidden', whiteSpace: 'nowrap', height: '2.3em'}}>
                    <b>{window.gettext('School Name')}:</b>&nbsp;
                    {this.props.school.name} - {this.props.school.city.name}
                </div>
                <div style={{overflow: 'hidden', whiteSpace: 'nowrap', height: '2.3em', fontSize: '.9em'}}>
                    <b>{window.gettext('Examination')} - {window.gettext('Grade')}:</b>&nbsp;
                    {this.props.examination.title} - {this.props.examination.grades[0].title}
                </div>
                <div style={{overflow: 'hidden', whiteSpace: 'nowrap', height: '2.3em'}}>
                    <b>{window.gettext('Holding Date')}:</b> {this.props.examination.date.toJalali().persian()}
                </div>
            </div>
            <div
                style={{
                    position: 'fixed',
                    top: '8mm',
                    right: '167mm',
                    width: '42mm',
                }}>
                <div style={{overflow: 'hidden', whiteSpace: 'nowrap', height: '2.3em'}}>
                    <b>{window.gettext('Participants')}:</b>
                    &nbsp;
                    {(this.props.examination.students_participated || '').persian()}
                </div>
                <div style={{overflow: 'hidden', whiteSpace: 'nowrap', height: '2.3em'}}>
                    <b>{window.gettext('Centers Participated')}:</b>
                    &nbsp;
                    {(this.props.examination.schools_participated || '').persian()}
                </div>
                <div style={{overflow: 'hidden', whiteSpace: 'nowrap', height: '2.3em'}}>
                    <b>{window.gettext('Rank Among Schools')}:</b>
                    &nbsp;
                    {(_.find(this.props.data, data => (
                        data.category_is_global &&
                        data.school === this.props.school.id &&
                        data.field === 31 &&
                        data.group_is_global
                    )) || {value: 0}).value.toFixed().persian()}
                </div>
            </div>
            <img
                style={{
                    position: 'fixed',
                    top: '4mm',
                    right: '4.5mm',
                    width: '33mm',
                }}
                src={imageUrl(window.images.logo, {
                    width: 200,
                    type: 'contain',
                })}
                onLoad={this.props.imageLoaded}
                onError={this.props.imageLoaded}
            />
            {/* <div */}
            {/*     style={{ */}
            {/*         position: 'fixed', */}
            {/*         top: '195mm', */}
            {/*         right: '16mm', */}
            {/*         width: '71mm', */}
            {/*     }}> */}
            {/*     <div style={{overflow: 'hidden', height: '2.3em'}}> */}
            {/*         <b>{window.gettext('Analyze Date')}:</b> {(this.props.examination.analyze_date || '').persian()} */}
            {/*     </div> */}
            {/* </div> */}
            {/* <div */}
            {/*     style={{ */}
            {/*         position: 'fixed', */}
            {/*         top: '195mm', */}
            {/*         right: '120mm', */}
            {/*         fontSize: '1.3em', */}
            {/*         fontFamily: 'Arial', */}
            {/*     }}> */}
            {/*     <b>www.mhelli.ir</b> */}
            {/* </div> */}
            <div
                style={{
                    position: 'fixed',
                    top: '40mm',
                    left: '12mm',
                    right: '7mm',
                }}>
                <div
                    style={{
                        width: '100%',
                        boxSizing: 'border-box',
                        padding: '1em',
                        textAlign: 'center',
                    }}>
                    <table
                        style={{
                            borderCollapse: 'collapse',
                            width: '100%',
                            border: '.0625em solid #eaeaea',
                        }}>
                        <thead>
                            <tr>
                                <Th rowSpan='2'>{window.gettext('Question')}</Th>
                                <Th rowSpan='2'>{window.gettext('Subject')}</Th>
                                <Mth rowSpan='2'>{window.gettext('Total Score')}</Mth>
                                <Mth
                                    colSpan='2'
                                    style={{borderRight: '.0625em solid #cacaca'}}>
                                    {window.gettext('Average')}
                                </Mth>
                            </tr>
                            <tr>
                                <Mth style={{borderRight: '.0625em solid #cacaca'}}>
                                    {this.props.class === 'school'
                                        ? window.gettext('School')
                                        : window.interpolate(
                                            window.gettext('Class %(class)s'),
                                            {class: this.props.className},
                                            true,
                                        )
                                    }
                                </Mth>
                                <Mth>
                                    {window.gettext('Country')}
                                </Mth>
                            </tr>
                        </thead>
                        <tbody>
                            {_.map(
                                _.filter(questions, question => this.props.subject === 'all' || _.some(
                                    question.subjects,
                                    subject => subject.root_subject === this.props.subject,
                                )),
                                question => <tr key={question.id}>
                                    <Td>{(question.index + 1).persian()}</Td>
                                    <Td>
                                        {_.map(_.uniq(_.union(..._.map(
                                            question.subjects,
                                            item => _.reverse(_.slice(item.subjects)),
                                        ))), item => subjects[item].title).join(' - ')}
                                    </Td>
                                    <Mtd>
                                        {_.sumBy(question.scores, 'score').toFixed(2).persian(true)}
                                    </Mtd>
                                    <Mtd style={{borderRight: '.0625em solid #cacaca'}}>
                                        {(_.find(this.props.data, data => (
                                            data.question == question.id &&
                                            data.field == 21 &&
                                            (
                                                this.props.class === 'school'
                                                ? data.school === this.props.school.id
                                                : data.clazz === this.props.class
                                            )
                                        )) || {value: 0}).value.toFixed(2).persian(true)}
                                    </Mtd>
                                    <Mtd>
                                        {(_.find(this.props.data, data => (
                                            data.question == question.id &&
                                            data.field == 21 &&
                                            data.is_global
                                        )) || {value: 0}).value.toFixed(2).persian(true)}
                                    </Mtd>
                                </tr>,
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>;
    }
}
